import { DEFAULT_LOCALE } from '@shared/lib/const';
import type { TAxiosError, TPagination, TPaginationParams } from '@shared/lib/types';
import { defaultLocale, LOCALE_NAMESPACES } from '@shared/lib/i18n';
import Cookies from 'js-cookie';
import type { getI18n } from 'react-i18next';
import type { ImageLoader } from 'next/image';
export const getErrorMessage = (error: TAxiosError) => error?.response?.data?.message;
export const getErrorDetails = (error?: TAxiosError | null) => error?.response?.data?.details;
export const getErrorTitle = (error?: TAxiosError) => {
  const status = error?.response?.status || '';
  const statusText = error?.response?.statusText || 'Ooooops! Something went wrong...';
  return `${status} ${statusText}`;
};
export const preparePagination = (pagination: TPagination): TPaginationParams => ({
  'page[limit]': pagination.limit,
  'page[offset]': pagination.offset
});
export const prepareFilters = (filters: Record<string, string>) => Object.entries(filters).reduce((result, [key, value]) => ({
  ...result,
  [`filter[${key}]`]: value
}), {} as Record<string, string>);
export function Uid(): string {
  return `_${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
}
export const getBase64FromUrl = (imageUrl: string, fetchOptions?: RequestInit): Promise<string> => fetch(imageUrl, fetchOptions).then(data => data.blob()).then(blob => window.URL.createObjectURL(blob));
export const capitalizeFirstLetter = (text = '') => text.charAt(0).toUpperCase() + text.slice(1);
export const formatDate = (date: number, options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
} as const) => new Date(date).toLocaleDateString(DEFAULT_LOCALE, options);
export const changeLanguage = async ({
  i18n,
  lng
}: TGetLocalesArgs) => {
  Cookies.set('LOCALE', lng);
  const namespacesToFetch = LOCALE_NAMESPACES.filter(ns => i18n.hasResourceBundle(i18n.resolvedLanguage || defaultLocale, ns) && !i18n.hasResourceBundle(lng, ns));
  const promises = namespacesToFetch.map(ns => fetch(`/locales/${lng}/${ns}.json`, {
    credentials: 'include'
  }).then(async res => {
    const response = await res.json();
    i18n.addResourceBundle(lng, ns, response, true, true);
  }));
  await Promise.all(promises).finally(() => i18n.changeLanguage(lng));
};
type TGetLocalesArgs = {
  i18n: ReturnType<typeof getI18n>;
  lng: string;
};
export const absolutePathImageLoader: ImageLoader = ({
  src,
  width,
  quality
}) => `${src}?w=${width}&q=${quality || 80}`;